module.exports = __webpack_public_path__ + "static/img/Candy.02bf7095.png";